/**
 * Highland App Template - Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeAWS } from './lib/awsConfig';
import { initializeMsal } from './lib/msalConfig';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Initialize AWS and MSAL configuration, then render the app
// Note: StrictMode removed due to incompatibility with react-beautiful-dnd v13 in React 18
// StrictMode double-renders components which breaks drag-drop state tracking
// Consider migrating to @hello-pangea/dnd for React 18 StrictMode support
Promise.all([
  initializeAWS(),
  initializeMsal().catch((error) => {
    // MSAL initialization is optional - don't block app startup
    console.warn('Azure AD not configured or initialization failed:', error);
    return null;
  }),
]).then(() => {
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}).catch((error) => {
  console.error('Failed to initialize app:', error);
  // Render the app anyway - it will show appropriate error states
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
});
